import { Middleware } from "redux";
import { RootState } from "../../../state";
import { serverRequest } from "../../../actions/app/api";
import { APP_URL, GET } from "../../../../_shared/constants";
import { GET_WHITELIST } from "../../../actions";

export const getWhitelist: Middleware<unknown, RootState> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    if (action.type === GET_WHITELIST.START) {
      const { id, payload, onFinish, ...rest } = action.meta;
      dispatch(
        serverRequest({
          method: GET,
          url: `${APP_URL.whitelist.get}/${id}`,
          onFinish,
          payload,
          onSuccess: GET_WHITELIST.SUCCESS,
          ...rest,
        })
      );
    }
  };
